import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useBreadcrumb } from "hooks/useBreadcrumb";
import Accordion from "components/General/Accordion";
import {
  useAgentFaqs,
  useVestedAgentsFaqs,
} from "js/placeholderData/agents/authed-agent-faqs";
import { useCustomerFaqs } from "js/placeholderData/authed-customer-faqs";
import { useUnauthCustomerFaqs } from "js/placeholderData/unauth-customer-faqs";
import { useUnauthAgentFaqs } from "js/placeholderData/agents/unauth-agent-faqs";

export default function HelpFaqs() {
  const location = useLocation();
  const { user } = useSelector((s) => s.user);
  const { agent } = useSelector((s) => s.getAgent);
  const unauthCustomerFaqs = useUnauthCustomerFaqs();
  const unauthAgentFaqs = useUnauthAgentFaqs();
  const customerFaqs = useCustomerFaqs();
  const agentFaqs = useAgentFaqs();
  const vestedAgentsFaqs = useVestedAgentsFaqs();
  const { t } = useTranslation();

  useBreadcrumb(
    "userId" in user
      ? user?.role?.portal === "Customer"
        ? [
            // customer routes
            {
              name: "Home",
              url: "/policies",
            },
            { name: "Help", url: "/help" },
            { name: "FAQs", url: "#" },
          ]
        : [
            // agent routes
            {
              name: "Home",
              url: "/dashboard",
            },
            { name: "Help", url: "/help" },
            { name: "FAQs", url: "#" },
          ]
      : location.pathname.indexOf("guest") > 0
      ? [
          // unauth routes
          {
            name: "Home",
            url: "/",
          },
          { name: "Help", url: "/guest/help" },
          { name: "FAQs", url: "#" },
        ]
      : [
          // unauth routes
          {
            name: "Home",
            url: "/",
          },
          { name: "Help", url: "/help" },
          { name: "FAQs", url: "#" },
        ]
  );
  return (
    <>
      <div className="container mb-8">
        <h1>{t("CustomerHelp-FAQsTitle")}</h1>
        <hr />
      </div>

      {/* FAQs */}
      <div className="container ui-component-spacing">
        <div className="grid grid-cols-1 gap-4">
          {"userId" in user
            ? user?.role?.portal === "Customer"
              ? customerFaqs.map((faq, idx) => (
                  <Accordion item={faq} key={`FAQ - ${idx}`} />
                ))
              : agent?.status?.toUpperCase() === "A"
              ? agentFaqs.map((faq, idx) => (
                  <Accordion item={faq} key={`FAQ - ${idx}`} />
                ))
              : vestedAgentsFaqs.map((faq, idx) => (
                  <Accordion item={faq} key={`FAQ - ${idx}`} />
                ))
            : location.pathname.indexOf("guest") > 0
            ? unauthCustomerFaqs.map((faq, idx) => (
                <Accordion item={faq} key={`FAQ - ${idx}`} />
              ))
            : unauthAgentFaqs.map((faq, idx) => (
                <Accordion item={faq} key={`FAQ - ${idx}`} />
              ))}
        </div>
      </div>
    </>
  );
}
